import { render, staticRenderFns } from "./FileNotFound.vue?vue&type=template&id=35ca5dc8&"
import script from "./FileNotFound.vue?vue&type=script&lang=js&"
export * from "./FileNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports